import PropTypes from 'prop-types';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { formatKpiValue, KPI_COLORS, pickLayout, rowValue } from '../kpiUtils';

const KpiGroupCard = ({ item }) => {
    const layout = pickLayout(item.layout, { md: 12, height: 'auto' });
    const config = item.config || {};
    const rows = item.rows || [];

    return (
        <Grid item xs={layout.xs} sm={layout.sm} md={layout.md} lg={layout.lg}>
            <Card elevation={0} sx={{ borderRadius: 3, border: '1px solid #EDE4F5', p: 1 }}>
                {item.titulo && (
                    <Typography variant="h5" sx={{ px: 1.5, pt: 1.5, pb: 0.5, fontWeight: 700, color: '#2A1638' }}>
                        {item.titulo}
                    </Typography>
                )}
                <CardContent>
                    <Grid container spacing={2}>
                        {rows.map((row, index) => {
                            const title = rowValue(row, config.labelKey, ['titulo', 'label', 'nome']);
                            const value = rowValue(row, config.valueKey, ['valor', 'value', 'total']);
                            const subtitle = rowValue(row, config.subtitleKey, ['subtitulo', 'label_secundario']);
                            const palette = config.colors && config.colors.length ? config.colors : KPI_COLORS;
                            const color = palette[index % palette.length];
                            return (
                                <Grid item xs={12} sm={6} md={rows.length > 4 ? 2 : 3} lg={rows.length > 4 ? 2 : 3} key={`${title}-${index}`}>
                                    <Box
                                        sx={{
                                            borderRadius: 2.5,
                                            p: 2,
                                            bgcolor: `${color}14`,
                                            borderLeft: `4px solid ${color}`
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ color: '#6B5A78', fontWeight: 600 }}>
                                            {title || `Item ${index + 1}`}
                                        </Typography>
                                        <Typography variant="h4" sx={{ fontWeight: 800, color: '#2A1638', mt: 0.5 }}>
                                            {formatKpiValue(value, config.format || 'number', config)}
                                        </Typography>
                                        {subtitle && (
                                            <Typography variant="caption" sx={{ color: '#6B5A78', display: 'block', mt: 0.5 }}>
                                                {subtitle}
                                            </Typography>
                                        )}
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
};

KpiGroupCard.propTypes = {
    item: PropTypes.object
};

export default KpiGroupCard;
